import { useEffect, useState } from 'react';
import videojs from 'video.js';

/**
 * Hook to detect if the user is navigating back either by clicking the
 * browser back button or by using the back button on the player
 * @returns {boolean} isNavigatingBack
 * @example
 * const isNavigatingBack = useIsNavigatingBack();
 * if (isNavigatingBack) reset the player and stop rendering the video
 */
export function useIsNavigatingBack(playerID: string): boolean {
  const [isNavigatingBack, setIsNavigatingBack] = useState<boolean>(false);

  useEffect(() => {
    window.addEventListener('popstate', handleBackButton);

    return () => {
      window.removeEventListener('popstate', handleBackButton);
    };
  }, []);

  function handleBackButton() {
    setIsNavigatingBack(true);

    // @ts-ignore
    const player = videojs(playerID);

    if (!player) return;

    player.reset();
  }

  return isNavigatingBack;
}
